export const checkoutTranslate = {
  es: {
    package: {
      solo: "",
      team: "",
    },
    referral: {
      title: "Beneficio de link de referido aplicado",
      content:
        "Has aplicado correctamente el link de referido que te compartieron",
      more: "Ver más",
    },
    modal: {
      title: "Obtén $100 mxn con tu link de referido",
      content:
        "Si contratas la membresía con este link de referido obtendrás saldo Viva Cash para tu siguiente reservación.",
      subContent:
        "Una vez finalizada la compra, podrás ver el saldo de regalo en tu perfil de Viva Aerobus.",
      footerContent:
        "Para utilizar el saldo deberás aceptar términos y condiciones de Viva Cash",
    },
    tabs: {
      information: "Datos Personales",
      summary: "Resumen y pago",
      membership: "Membresía",
    },
    details: {
      title: "Detalles",
      type: "Tipo de membresía",
      team: "Fecha de expiración",
      renewalTitle: "Renovación automática",
      renewalContent(date) {
        return `Tu membresía se renovará automáticamente el ${date}. Puedes cancelar la renovación en cualquier momento antes de esta fecha.`;
      },
      renewalSubContent:
        "El cobro mensual se realizará de forma automática durante 12 meses al método de pago elegido",
      membershipCost: "Costo membresía",
      teamExtra: "Acompañante extra",
      yearDiscount: "Descuento primer año",
      totalPay: "Total a pagar",
      totalMembership: "Costo total de membresía",
      month: "Meses",
      cardDetails:
        "Por favor ingresa los datos de tu tarjeta digital para pagos con BBVA",
    },
    user: {
      headerTitle: "Titular de la membresía",
      dob: "Fecha de nacimiento",
      email: "Email",
      signoff: "Cerrar sesión",
      change: "Cambiar datos",
      changeCCTitle: "Cambiar tarjeta de débito o crédito",
      confirm: "Confirmar datos",
      membershipSettings: "Configuración de la membresía",
      membershipType: "Tipo de membresía",
      memebershipIndividual: "Membresía individual",
      memebershipTeam: "Membresía Team",
      membershipChoose:
        "Elige si quieres compartir el descuento Viva Fan con tus acompañantes",
      membershipCompanions: "Acompañantes en la membresía",
      share: (number) => {
        return `La membresía incluye ${number} beneficiario${
          number > 1 ? "s" : ""
        }, agrega hasta 7 adicionales para completar 9`;
      },
      numberCompanions: "Número de acompañantes",
      membership: "Costo por acompañante",
      extraCompanion: "Costo total de acompañantes",
      paymentType: "Tipo de pago",
      reccurence:
        "Elige la recurrencia de cobro para el primer año de tu membresía",
      monthlyCharge: "Cobro mensual",
      annualCharge: "Cobro anual",
      annualSave: "(Ahorras 15%)",
      companions: "Acompañantes",
      increaseCompanionsTeam: () => {
        return `Puedes incrementar acompañantes hasta 3 meses después de tu contratación.`;
      },
      increaseCompanionsSolo: () => {
        return `Puedes incrementar acompañantes hasta 3 meses después de tu contratación.`;
      },
      //increaseCompanionsSolo : ( price, currency ) => { return `Puedes incrementar acompañantes hasta 3 meses después de tu contratación $${price} ${currency} mensuales a partir del segundo año` },
      companionsEdit: (companionNumber, remainingNumber) => {
        return remainingNumber != 0
          ? `Tu membresía tiene ${companionNumber} beneficiario${
              companionNumber > 1 ? "s" : ""
            } , puedes agregar ${remainingNumber} persona${
              remainingNumber > 1 ? "s" : ""
            } más.`
          : `Has alcanzado el número máximo de acompañantes en tu membresía Viva Fan`;
      },
      paymentMethod: "Método de pago",
      creditCard: "Tarjeta de crédito o débito",
      cardNumber: "Número de tarjeta",
      cardExpiry: "MM/AA",
      cardExpiration: "Vencimiento",
      cardName: "Nombre(s)",
      cardLastname: "Apellidos",
      exCardName: "Ej. Miranda",
      exCardLName: "Ej. Rodriguez",
      direction: "Dirección",
      exDirection: "Ej. Emilio Zapata 123...",
      country: "País",
      city: "Ciudad",
      exCity: "Ej. Ciudad de México",
      postalCode: "Código postal",
      exPostalCode: "Ej.12345",
    },
    promotion: {
      show: "Agregar código promocional",
      hide: "Ocultar código promocional",
      promotion: "Código de promoción",
      ex: "Ej.",
      apply: "Aplicar",
    },
    payment: {
      text: `Al finalizar la compra aceptas haber leído y estar de acuerdo con el <a href='https://content.vivaaerobus.com/Upload-VB/legal/aviso-de-privacidad-integral-comercial-vb.pdf' class='underline' target="_blank"> aviso de privacidad </a> y los <a href='https://www.vivaaerobus.com/mx/info/terminos-y-condiciones-completos' class='underline' target="_blank">términos y condiciones. </a>`,
      monthly: "Pago mensual",
      annual: "Pago anual",
      pay: "Pagar",
      month: "meses",
      yearly: "anual",
      monthlyy: "mensual",
      changetitle: "El método de pago reemplazará al actual",
      changesubtitle:
        "Para modificar el método de pago, es necesario estar libre de adeudos e ingresar un método válido.",
    },
    checkout: {
      title: "Recibiste $100mxn de regalo",
      content:
        "Tú y la persona que compartió contigo su link de referido ha recibido saldo Viva Cash para su siguiente reservación",
      subContent:
        "Para utilizar el saldo deberás aceptar términos y condiciones de Viva Cash en tu perfil de Viva Aerobus",
      viewBtn: "Ver Mi Perfil",
    },
    button: {
      change: "Confirmar cambio",
      cancel: "Cancelar",
    },
    companions: {
      SubscriptionPendingChange:
        "Tu suscripción tiene un cambio pendiente. No puedes añadir acompañantes.",
    },
    subscription: {
      change: {
        title: (language, description, changeSubscription) => {
          const changeDate = new Date(changeSubscription.effectiveDate);
          const options = { year: "numeric", month: "long", day: "numeric" };
          const lang = language == "es" ? "es-ES" : "en-US";

          const newDate = changeDate.toLocaleDateString(lang, options);
          return `Cambios aplicarán a partir de ${newDate} en tu siguiente renovación`;
        },
        subtitle:
          "Solo puedes modificar a tus acompañantes hasta 3 meses después de contratar Viva Fan",
      },
    },
  },
  eng: {
    package: {
      solo: "Travel alone",
      team: "Travel accompanied",
    },
    referral: {
      title: "Referral link benefit applied",
      content:
        "You have successfully applied the referral link that was shared with you",
      more: "See more",
    },
    user: {
      headerTitle: "Holder data",
      dob: "Date of birth",
      email: "E-mail",
      changeCCTitle: "Change debit or credit card",
      signoff: "Sign off",
      change: "change data",
      confirm: "Confirm data",
      membershipSettings: "Membership Settings",
      membershipType: "Membership Type",
      memebershipIndividual: "Individual Membership",
      memebershipTeam: "Team Membership Team",
      membershipChoose:
        "Choose if you want to share the Viva Fan discount with your companions",
      membershipCompanions: "Companions in the membership",
      share: (number) => {
        return `The membership already includes ${number} beneficiarie${
          number > 1 ? "s" : ""
        }, add up to 7 more to complete 9`;
      },
      companionsEdit: (companionNumber, remainingNumber) => {
        return remainingNumber != 0
          ? `Your membership has ${companionNumber} beneficiarie${
              companionNumber > 1 ? "s" : ""
            }, you can add ${remainingNumber} more people.`
          : `You have reached the maximum number of companions in your Viva Fan membership`;
      },
      direction: "Address",
      numberCompanions: "Number of companions",
      membership: "Cost per companion",
      extraCompanion: "Total cost of companions",
      paymentType: "Payment type",
      reccurence:
        "Choose the recurrence of payment for the first year of your membership",
      monthlyCharge: "Monthly charge",
      annualCharge: "Annual charge",
      annualSave: "(You save 15%)",
      increaseCompanionsTeam: () => {
        return `You can increase companions up to 3 months after your hiring.`;
      },
      //increaseCompanionsTeam : ( team, currency ) => { return  `You can increase companions up to 3 months after your hiring $${team} ${currency} monthly from the second year`} ,
      // increaseCompanionsSolo : ( price, currency ) =>  { return `You can increase companions up to 3 months after your hiring $${price} ${currency} monthly from the second year` },
      increaseCompanionsSolo: () => {
        return `You can increase companions up to 3 months after your hiring.`;
      },
      paymentMethod: "Payment method",
      creditCard: "Credit or debit card",
      cardNumber: "Card number",
      cardExpiry: "MM/YY",
      cardExpiration: "Expiration",
      cardName: "Name(s)",
      cardLastname: "Surnames",
      exCardName: "Ex. Miranda",
      exCardLName: "Ex. Rodriguez",
      exDirection: "Ex. Emilio Zapata 123...",
      country: "Country",
      city: "City",
      companions: "Companions",
      exCity: "Ex. Ciudad de México",
      postalCode: "Postal Code",
      exPostalCode: "Ex.12345",
    },
    details: {
      title: "Details",
      type: "Membership Type",
      team: "Expiration date",
      renewalTitle: "Automatic renewal",
      renewalContent(date) {
        return `Your membership will automatically renew on ${date}. You can cancel the renewal at any time before this date.`;
      },
      renewalSubContent:
        "The monthly charge will be made automatically for 12 months to the chosen payment method",
      membershipCost: "Membership cost",
      teamExtra: " Extra Companion",
      yearDiscount: "First year discount",
      totalPay: "Total to pay",
      totalMembership: "Total cost of membership",
      month: "Month",
      cardDetails:
        "Please enter your digital card details for payments with BBVA",
    },
    promotion: {
      show: "Add promotional code",
      hide: "Hide promotional code",
      promotion: "Promotion Code",
      ex: "Ex.",
      apply: "Apply",
    },
    modal: {
      title: "Get $100 mxn with your referral link",
      content:
        "If you contract the membership with this link you will obtain a Viva Cash balance for your next reservation.",
      subContent:
        "Once the purchase is complete, you will be able to see the gift balance in your Viva Aerobus profile.",
      footerContent:
        "To use the balance you must accept the terms and conditions of Viva Cash",
    },
    payment: {
      text: "At the end of the purchase you agree to have read and agree to the  <a href='https://content.vivaaerobus.com/Upload-VB/legal/aviso-de-privacidad-integral-comercial-vb.pdf' class='underline'> privacy notice </a> and the  <a href='https://www.vivaaerobus.com/mx/info/terminos-y-condiciones-completos' class='underline'>terms and conditions.</a>",
      monthly: "Monthly payment",
      annual: "Annual Payment",
      pay: "Pay",
      month: "monthly",
      yearly: "yearly",
      monthlyy: "annually",

      changetitle: "Your payment method  will replace the current one",
      changesubtitle:
        "To modify your payment method, it must be valid and your account without charges.",
    },
    tabs: {
      information: "Personal information",
      summary: "Summary and payment",
      membership: "Membership",
    },
    checkout: {
      title: "You received $100mxn as a gift",
      content:
        "You and the person who shared your referral link with you have received a Viva Cash balance for their next reservation",
      subContent:
        "To use the balance you must accept the terms and conditions of Viva Cash in your Viva Aerobus profile",
      viewBtn: "View my profile",
    },
    button: {
      change: "Confirm change",
      cancel: "Cancel",
    },
    companions: {
      SubscriptionPendingChange: `Your subscription has a pending change. You can't add companions.`,
    },
    subscription: {
      change: {
        title: (language, description, changeSubscription) => {
          const changeDate = new Date(changeSubscription.effectiveDate);
          const options = { year: "numeric", month: "long", day: "numeric" };
          const lang = language.value == "es" ? "es-ES" : "en-US";

          const newDate = changeDate.toLocaleDateString(lang, options);
          return `Your subscription plan will change on ${newDate}`;
        },
        subtitle:
          "You can only modify your companions up to 3 months after contracting Viva Fan.",
      },
    },
  },
};
